<script>
  export let src, srcset
</script>

<img {src} {srcset} />

<style>
  img {
    object-fit: contain;
    width: 100%;
    max-height: 100%;
    display: block;
  }
</style>
